const permissions = {
  listReportsConsole: 'MR001',
};

export default permissions;
